<template>
  <div class='qrcode-modal'>
    <mt-popup v-model="bshow"
              class='guestInfo-delay'
              popup-transition="popup-fade">
      <div class='delayIn-main' ref="poster">
        <h2>{{ $t('scanPay_title') }}</h2>
        <div class="guestSwiper">
          <div class="info">
            <label>{{ $t('memberDetailPay_payment') }} </label>
            <div class="parent">
               <gpicker ref="payCode" :placeholder="$t('msg_choose_checkMethod')"></gpicker>
            </div>
          </div>
          <div class="info">
            <label>{{$t('fangTXQ_transactionAmount')}}</label>
            <div class="parent">
               <input class="inp"
                   type="number"
                   :placeholder="$t('fangTXQ_pleaseTransactionAmount')"
                   v-model='price'>
            </div>
          </div>
        </div>
        <div class="btn">
          <div class="unSure"
               @click="onCancel">{{ $t('cancel') }}
          </div>
          <div class="sure"
               @click="onExport">{{$t('fangTXQ_generateQrCode')}}
          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
import {Toast} from "mint-ui";
import gpicker from "@/components/common/gpicker";

export default {
  data() {
    return {
      bshow: false,
      sharewx: null,
      price:'',
      masterId:''
    };
  },
  props: {},
  components:{
    gpicker
  },
  methods: {
    show(data) {
      this.bshow = true;
      this.masterId = data;
      this.listscanpaychannel();
    },
    disCodeName(v) {
      return v.code + ' -- ' + v.name;
    },
    onExport(){
      if (_.isEmpty(this.price)) {
        return this.msg2(this.$t('fangTXQ_cannotTransactionAmount'));
      }
      this.createQrCodeWithAccntType();
      //
    },
    onCancel(){
      this.bshow = false;
      this.price = "";
      this.masterId = "";
    },
    //获取支付方式
    listscanpaychannel() {
      this.$http.post('/mobilepmsapi/pay/listscanpaychannel').then(res => {
        if (res.data.result == 0) {
          let _retVal = res.data.retVal;
          let _resultInfo = _retVal.resultInfo ? _retVal.resultInfo : [];
          _resultInfo.map(item=>{
            item.name = item.descript;
            return item
          })
          this.$refs.payCode.setData(_resultInfo, _resultInfo[0].code, this.disCodeName);
        } else {
          this.msg2(res.data.msg)
        }
      });
    },
    //获取支付图片的url接口
    createQrCodeWithAccntType() {
      this.$http.post('/mobilepmsapi/pay/createQrCodeWithAccntType',{
        masterId: this.masterId,
        totalFee: this.price,
        scanChannel: this.$refs.payCode.getValue()
      }).then(res => {
        if (res.data.result == 0) {
          let _retVal = res.data.retVal;
          let _resultInfo = _retVal.resultInfo ? _retVal.resultInfo : '';
          this.$emit("emitFormQrCode",{
            src:_resultInfo,
            price:this.price
          })
          this.onCancel();
        } else {
          this.msg2(res.data.msg)
        }
      });
    },
  },
};
</script>

<style lang='less' scoped>
.qrcode-modal {

  .guestInfo-delay {
    width: 100%;
    position: absolute;
    margin: 0 auto;
    padding: 0 15px;
    box-sizing: border-box;
    background: none;

    .delayIn-main {
      background: #fff;
      width: 100%;
      margin: 0 auto;
      box-sizing: border-box;
      border-radius: 10px;
    }

    h2 {
      font-size: 18px;
      color: #666666;
      text-align: center;
      font-style: normal;
      padding: 15px 0;
    }

    .mint-cell-title {
      width: 80px;
    }

    .guestSwiper {
      padding: 0.5rem;
      .info {
        box-sizing: border-box;
        margin: 0 auto;
        margin: 0.12rem auto;
        overflow: hidden;
        line-height: 0.88rem;
        display: flex;
        label {
          box-sizing: border-box;
          padding-left: 0.13333333rem;
          float: left;
          text-align: left;
          width: 2.33333333rem;
          font-size: 0.33333333rem;
        }
        .parent {
          position: relative;
          margin: 0 0.13333333rem;
          padding: 0 0.13333333rem;
          float: left;
          flex:1;
          box-sizing: border-box;
          background: #fff;
          border: 1px solid #e8e8e8;

          &.focus {
            border: 1px solid #e0b47b;

            .iconfont {
              color: #e0b47b;
            }
          }

          input {
            border: none;
            width: 100%;
            height: 0.82rem;
            box-sizing: border-box;
          }

          .iconfont {
            position: absolute;
            right: 0.26666667rem;
            top: 0px;
            /* transform: rotate(-90deg);*/
          }
          /deep/ .area_ctrl{
            bottom: auto;
          }
          .info-input {
            float: right;
            width: 6.86666667rem;
            height: 0.88rem;
            border: 1px solid #e8e8e8;
            margin: 0 0.13333333rem;
            padding: 0 0.13333333rem;
            box-sizing: border-box;
            -webkit-appearance: none;
            outline: 0;

            &:focus {
              // border: 1px solid #e0b47b;
            }
          }
        }
      }

    }

    .btn {
      height: 55px;
      border-top: 1px solid #bdbdbd;
      text-align: center;
      font-size: 16px;
      width: 100%;
      display: flex;

      .unSure {
        flex: 1;
        box-sizing: border-box;
        line-height: 55px;
      }

      .sure {
        flex: 1;
        border-left: 1px solid #bdbdbd;
        box-sizing: border-box;
        line-height: 55px;
        color: #5190c3;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// formQrCodeModal.vue?68417528